var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6421 \xE2\x80\x93 105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 18020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5953",
    d: "M12.385 4.71839C12.58 4.52314 12.7347 4.29134 12.8402 4.03623C12.9458 3.78113 13.0001 3.5077 13.0001 3.23158C13.0001 2.95545 12.9458 2.68203 12.8402 2.42692C12.7347 2.17181 12.58 1.94002 12.385 1.74476C12.19 1.54951 11.9585 1.39463 11.7037 1.28896C11.4489 1.18329 11.1758 1.12891 10.9 1.12891C10.6242 1.12891 10.3511 1.18329 10.0963 1.28896C9.84153 1.39463 9.61001 1.54951 9.415 1.74476L1 10.14V13.1437H4L12.385 4.71839Z",
    stroke: "#0B1B4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5954",
    d: "M8.55859 2.58398L11.5586 5.58765",
    stroke: "#0B1B4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit-icon.6605c62d7f474412a5706137c9579d71.svg";
export { ForwardRef as ReactComponent };